// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark .product-variants-form {
  background: var(--black1);
}
.dark .product-variants-form textarea.paylixecommerce-input {
  background-color: var(--white);
}
.dark .product-variants-form .paylixecommerce-input {
  background-color: var(--white);
}
.dark .product-variants-form .paylixecommerce-select {
  background-color: var(--white);
}
.dark .product-variants-form button.primary:disabled {
  border: 1px solid var(--black6);
}

.product-variants {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 1rem;
  margin-top: 0;
}
.product-variants-form {
  border: 1px solid var(--black2);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 0.5rem;
  padding: 1.25rem;
}
.product-variants .product-variant {
  width: 100%;
  font-size: 1rem;
  padding: 1rem;
  cursor: pointer;
  border: 1px solid var(--black2);
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  background: var(--black0);
}
.product-variants .product-variant.red-border {
  border-color: var(--red6);
}
.product-variants .product-variant > div {
  display: flex;
}
.product-variants .product-variant-image {
  width: 40px;
  height: 40px;
  border-radius: 0.5rem;
  margin-right: 1rem;
  border: 1px solid var(--black1);
  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--black2);
}
.product-variants .product-variant-description {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-evenly;
}
.product-variants .product-variant-description > div:first-child {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
}
.product-variants .product-variant-description > div:last-child {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: var(--black4);
}
.product-variants .product-variant:first-child {
  margin-top: 1rem;
}

.product-variant.add.red {
  border-color: var(--red6);
}

.assets-modal {
  max-width: 70vw;
  max-height: 70vh;
  min-height: 70vh;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .assets-modal {
    max-width: calc(100vw - 4rem);
    max-height: calc(100vh - 4rem);
    min-height: calc(100vh - 4rem);
  }
}
@media (max-width: 768px) {
  .assets-modal {
    max-width: calc(100vw - 2rem);
    max-height: calc(100vh - 2rem);
    min-height: calc(100vh - 2rem);
  }
}
.assets-modal .paylixecommerce-modal-body {
  flex: 1;
  overflow-y: auto;
}
@media (max-width: 768px) {
  .assets-modal .paylixecommerce-modal-body {
    padding: 1rem;
  }
}

.subscription-badge {
  display: flex;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
}
.subscription-badge > span, .subscription-badge i {
  color: var(--black9);
}
.subscription-badge > span {
  margin-right: 0.5rem;
}
.subscription-badge-container {
  position: absolute;
  top: 0;
  right: calc(46px + 0.5rem);
  display: flex;
  align-items: center;
  justify-content: center;
}
.subscription-badge-container .subscription-tooltip {
  border: 1px solid var(--black1);
  opacity: 0.95;
  background: var(--white);
  padding: 0.6rem;
  border-radius: 0.5rem;
  font-size: 14px;
  color: var(--black9);
  line-height: 22px;
  width: 100%;
  max-width: 250px;
}
.subscription-badge-container .subscription-tooltip:after {
  border-top-color: var(--black1) !important;
}
.subscription-badge-container > span {
  cursor: pointer;
  color: var(--black9);
  margin-right: 0.5rem;
}

.title-price-widget {
  display: flex;
}
@media (max-width: 768px) {
  .title-price-widget {
    flex-wrap: wrap;
  }
}

.dark .price-input select.variant-price {
  border-right: 1px solid var(--black1);
  background: var(--black1);
}
.dark .price-input select.variant-price:focus {
  border-right-color: var(--purple6);
}

.price-input > label {
  margin-bottom: 0.75rem;
}
.price-input input {
  border-radius: 0 6px 6px 0 !important;
}
.price-input select {
  width: 140px;
  border-right: 0;
  border-radius: 6px 0 0 6px;
}
.price-input select.variant-price {
  width: 100%;
  margin-bottom: 1rem;
  border-right: 1px solid var(--black1);
  border-radius: 6px;
  background: var(--white);
}

.type-widget {
  background: var(--black0);
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  padding: 0 0.25rem;
}
.type-widget.error > div {
  border-color: var(--red6);
}
.type-widget.error > div button {
  border-right-color: var(--red6);
}
.type-widget-error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: var(--red6);
  display: flex;
}
.type-widget > div {
  display: inline-flex;
  height: 2rem;
  align-items: center;
  justify-content: space-around;
  border-radius: 0.5rem;
  width: 100%;
}
.type-widget > div button {
  padding: 0;
  background: transparent;
  cursor: pointer;
  height: 100%;
  align-items: center;
  display: flex;
  outline: none;
  width: calc(20% - 0.5rem);
  justify-content: center;
  border: none;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: var(--black4);
  border-radius: 0.5rem;
  flex: 1;
}
@media (max-width: 768px) {
  .type-widget > div button {
    word-break: break-word;
    font-size: 0.8rem;
  }
}
.type-widget > div button:last-of-type {
  border-right: none;
}
.type-widget > div button.active {
  background: var(--white);
  color: var(--black9);
  box-shadow: 0 2px 8px -1px rgba(7, 14, 35, 0.05);
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/product/screens/components/variant-info/index.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;AAAJ;AAEI;EACE,8BAAA;AAAN;AAEI;EACE,8BAAA;AAAN;AAEI;EACE,8BAAA;AAAN;AAEI;EACE,+BAAA;AAAN;;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;AAFF;AAIE;EACE,+BAAA;EACA,4CAAA;EACA,qBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,+BAAA;EACA,8CAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,yBAAA;AAHJ;AAKI;EACE,yBAAA;AAHN;AAMI;EACE,aAAA;AAJN;AAOI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,+BAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AALN;AAQI;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,6BAAA;AANN;AASQ;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAPV;AASQ;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAPV;AAYI;EACE,gBAAA;AAVN;;AAiBE;EACE,yBAAA;AAdJ;;AAmBA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAhBF;AAkBE;EATF;IAUI,6BAAA;IACA,8BAAA;IACA,8BAAA;EAfF;AACF;AAiBE;EAfF;IAgBI,6BAAA;IACA,8BAAA;IACA,8BAAA;EAdF;AACF;AAgBE;EACE,OAAA;EACA,gBAAA;AAdJ;AAgBI;EAJF;IAKI,aAAA;EAbJ;AACF;;AAiBA;EACE,aAAA;EAEA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAfF;AAiBE;EACE,oBAAA;AAfJ;AAkBE;EACE,oBAAA;AAhBJ;AAmBE;EACE,kBAAA;EACA,MAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBJ;AAmBI;EACE,+BAAA;EACA,aAAA;EACA,wBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AAjBN;AAmBM;EACE,0CAAA;AAjBR;AAqBI;EACE,eAAA;EACA,oBAAA;EACA,oBAAA;AAnBN;;AAwBA;EACE,aAAA;AArBF;AAuBE;EAHF;IAII,eAAA;EApBF;AACF;;AA0BM;EACE,qCAAA;EACA,yBAAA;AAvBR;AAyBQ;EACE,kCAAA;AAvBV;;AAgCE;EACE,sBAAA;AA7BJ;AAgCE;EACE,qCAAA;AA9BJ;AAiCE;EACE,YAAA;EACA,eAAA;EACA,0BAAA;AA/BJ;AAiCI;EACE,WAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,wBAAA;AA/BN;;AAqCA;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;AAlCF;AAqCI;EACE,yBAAA;AAnCN;AAqCM;EACE,+BAAA;AAnCR;AAwCE;EACE,WAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;AAtCJ;AAyCE;EACE,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,WAAA;AAvCJ;AAyCI;EACE,UAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,OAAA;AAvCN;AAyCM;EArBF;IAsBI,sBAAA;IACA,iBAAA;EAtCN;AACF;AAyCM;EACE,kBAAA;AAvCR;AA0CM;EACE,wBAAA;EACA,oBAAA;EACA,gDAAA;AAxCR","sourcesContent":[".dark {\n  .product-variants-form {\n    background: var(--black1);\n\n    textarea.paylixecommerce-input {\n      background-color: var(--white);\n    }\n    .paylixecommerce-input {\n      background-color: var(--white);\n    }\n    .paylixecommerce-select {\n      background-color: var(--white);\n    }\n    button.primary:disabled {\n      border: 1px solid var(--black6);\n    }\n  }\n}\n\n.product-variants {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n  margin-bottom: 1rem;\n  margin-top: 0;\n\n  &-form {\n    border: 1px solid var(--black2);\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);\n    border-radius: .5rem;\n    padding: 1.25rem;\n  }\n\n  .product-variant {\n    width: 100%;\n    font-size: 1rem;\n    padding: 1rem;\n    cursor: pointer;\n    border: 1px solid var(--black2);\n    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);\n    border-radius: .5rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: .5rem;\n    background: var(--black0);\n\n    &.red-border {\n      border-color: var(--red6);\n    }\n\n    & > div {\n      display: flex;\n    }\n\n    &-image {\n      width: 40px;\n      height: 40px;\n      border-radius: .5rem;\n      margin-right: 1rem;\n      border: 1px solid var(--black1);\n      box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: var(--black2);\n    }\n\n    &-description {\n      display: flex;\n      align-items: flex-start;\n      flex-direction: column;\n      justify-content: space-evenly;\n\n      & > div {\n        &:first-child {\n          font-family: 'Inter';\n          font-style: normal;\n          font-weight: 500;\n          font-size: 14px;\n          line-height: 17px;\n          color: var(--black9);\n        }\n        &:last-child {\n          font-family: 'Inter';\n          font-style: normal;\n          font-weight: 500;\n          font-size: 13px;\n          line-height: 18px;\n          color: var(--black4);\n        }\n      }\n    }\n\n    &:first-child {\n      margin-top: 1rem;\n    }\n\n  }\n}\n\n.product-variant.add {\n  &.red {\n    border-color: var(--red6);\n  }\n}\n\n\n.assets-modal {\n  max-width: calc(70vw);\n  max-height: calc(70vh);\n  min-height: calc(70vh);\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1024px) {\n    max-width: calc(100vw - 4rem);\n    max-height: calc(100vh - 4rem);\n    min-height: calc(100vh - 4rem);\n  }\n\n  @media (max-width: 768px) {\n    max-width: calc(100vw - 2rem);\n    max-height: calc(100vh - 2rem);\n    min-height: calc(100vh - 2rem);\n  }\n\n  .paylixecommerce-modal-body {\n    flex: 1;\n    overflow-y: auto;\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n    }\n  }\n}\n\n.subscription-badge {\n  display: flex;\n  //padding: .25rem;\n  border-radius: 5px;\n  align-items: center;\n  justify-content: center;\n\n  & > span, i {\n    color: var(--black9);\n  }\n\n  & > span {\n    margin-right: .5rem;\n  }\n\n  &-container {\n    position: absolute;\n    top: 0;\n    right: calc(46px + .5rem);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .subscription-tooltip {\n      border: 1px solid var(--black1);\n      opacity: .95;\n      background: var(--white);\n      padding: .6rem;\n      border-radius: .5rem;\n      font-size: 14px;\n      color: var(--black9);\n      line-height: 22px;\n      width: 100%;\n      max-width: 250px;\n\n      &:after {\n        border-top-color: var(--black1) !important;\n      }\n    }\n\n    & > span {\n      cursor: pointer;\n      color: var(--black9);\n      margin-right: .5rem;\n    }\n  }\n}\n\n.title-price-widget {\n  display: flex;\n\n  @media (max-width: 768px) {\n    flex-wrap: wrap;\n  }\n}\n\n.dark {\n  .price-input {\n    select {\n      &.variant-price {\n        border-right: 1px solid var(--black1);\n        background: var(--black1);\n\n        &:focus {\n          border-right-color: var(--purple6);\n        }\n      }\n    }\n  }\n\n}\n\n.price-input {\n  & > label {\n    margin-bottom: .75rem;\n  }\n\n  input {\n    border-radius: 0 6px 6px 0 !important;\n  }\n\n  select {\n    width: 140px;\n    border-right: 0;\n    border-radius: 6px 0 0 6px;\n\n    &.variant-price {\n      width: 100%;\n      margin-bottom: 1rem;\n      border-right: 1px solid var(--black1);\n      border-radius: 6px;\n      background: var(--white);\n    }\n  }\n}\n\n\n.type-widget {\n  background: var(--black0);\n  height: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: .5rem;\n  padding: 0 0.25rem;\n\n  &.error {\n    & > div {\n      border-color: var(--red6);\n\n      button {\n        border-right-color: var(--red6);\n      }\n    }\n  }\n\n  &-error {\n    width: 100%;\n    margin-top: 0.25rem;\n    font-size: 80%;\n    color: var(--red6);\n    display: flex;\n  }\n\n  & > div {\n    display: inline-flex;\n    height: 2rem;\n    align-items: center;\n    justify-content: space-around;\n    border-radius: .5rem;\n    width: 100%;\n\n    button {\n      padding: 0;\n      background: transparent;\n      cursor: pointer;\n      height: 100%;\n      align-items: center;\n      display: flex;\n      outline: none;\n      width: calc(20% - .5rem);\n      justify-content: center;\n      border: none;\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 17px;\n      text-align: center;\n      color: var(--black4);\n      border-radius: .5rem;\n      flex: 1;\n\n      @media (max-width: 768px) {\n        word-break: break-word;\n        font-size: .8rem;\n      }\n\n\n      &:last-of-type {\n        border-right: none;\n      }\n\n      &.active {\n        background: var(--white);\n        color: var(--black9);\n        box-shadow: 0 2px 8px -1px rgb(7 14 35 / 5%);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
